import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FinancialsRoutingModule } from './financials-routing.module';
import { FinancialReportComponent } from './components/financial-report/financial-report.component';
import {AgGridModule} from "ag-grid-angular";
import {FinancialsService} from "../../services/modules/financials/financials.service";
import { FinancialsComponent } from './financials.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    FinancialsComponent,
    FinancialReportComponent,
    TransactionsComponent
  ],
    imports: [
        CommonModule,
        FinancialsRoutingModule,
        AgGridModule,
        FormsModule,
        SharedModule
    ]
})


export class FinancialsModule {
}

